import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Observable } from 'rxjs';
import { DevicesProvider } from '../../providers/devices/devices';
import { TasksProvider } from '../../providers/tasks/tasks';
import { Component, ViewEncapsulation } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, AlertController, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { TaskQL, Task, TaskData } from '../../providers/tasks/models';
import { UserProvider } from '../../providers/users/users';
import { UtilsProvider } from '../../providers/utils/utils';
import { SchedulerModalPage } from '../scheduler-modal/scheduler-modal';
import { AuthProvider } from '../../providers/auth/auth';
import { TasksPage } from '../tasks/tasks';

@IonicPage()
@Component({
  selector: 'page-task-schedule',
  templateUrl: 'task-schedule.html',
  encapsulation: ViewEncapsulation.None,
})
export class TaskSchedulePage {
  private task: TaskQL;
  private code: string = '';
  private ready: boolean;
  private taskData: TaskData;
  private extras: any;
  private isrepair: boolean = false;
  private isreplace: boolean = false;
  private serial: string;
  private showTypeBox: boolean = false;
  showBrowserScanner: boolean = false;
  private torch: boolean = false;
  private scanCodeVerified: boolean = false;
  private enableFlaslight: boolean = false;
  public loading: boolean = false
  public canSchedule: boolean = false;
  public selectedInstaller: string = '';
  public selectedInstallerName: string = '';
  public selectedDate: string = '';
  public selectedTime: string = '';
  public sendNotification: boolean = false;
  public avalibilityCheckInProgress: boolean = false;
  public installerBusy: boolean = false;
  public now: string = '';
  private loader: any;

  public installers: any[];
  devicePass: string;

  cameras: any;
  selectedCamera: any = null;
  public newNote: string = '';
  public initialDate: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private barcodeScanner: BarcodeScanner,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private userProvider: UserProvider,
    public platform: Platform,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private toastController: ToastController,
    private utilsProvider: UtilsProvider,
    private modalCtrl: ModalController,
    private authProvider: AuthProvider
  ) {
    this.task = this.navParams.get('task');
    this.extras = this.navParams.get('extras');
    this.isrepair = this.extras && this.extras.isrepair ? this.extras.isrepair : null;
    this.isreplace = this.extras && this.extras.isreplace ? this.extras.isreplace : null;
  }

  ionViewDidLoad() { }
  ionViewDidEnter() {
    this.setInitialDateVal();
    this.taskData = this.tasksProvider.getTaskData(this.task.id);
    this.now = new Date().toISOString();
    this.sendNotification = this.task.notify;
    this.readyCheck();
    this.presentLoading();
    this.userProvider.getUsers().subscribe(result => {
      this.loader.dismiss();
      this.installers = result;
      this.resetInstallerAvalibility();
    })
  }

  isCordova() {
    return this.platform.is('cordova');
  }
  async photoLight() {
    this.torch = !this.torch;
  }

  resetInstallerAvalibility(){
    this.installers = this.installers.map(installer => {
      installer.available = false;
      return installer;
    })
  }


  scanCode() {
    this.showTypeBox = false;
    const isCordova = this.isCordova();
    if (isCordova) {
      this.barcodeScanner.scan().then(
        barcodeData => {
          this.code = barcodeData.text;
          this.checkAndVerifyCode().subscribe(result => {
            if (result) {
              this.readyCheck();
              this.updateTask();
            }
          });
        },
        err => {
          // error
          alert(err);
          console.log(err);
        }
      );
    } else {
      this.browserScanner();
    }
  }

  noCordovaUpdate() {
    this.checkAndVerifyCode().subscribe(result => {
      if (result) {
        this.readyCheck();
        this.updateTask();
      }
    });
  }

  checkAndVerifyCode() {
    return Observable.create(observer => {
      let flag = false;
      // this.serial = this.devicesProvider.qrCodeToSerial(this.code);
      this.devicesProvider.qrCodeParseValidated(this.code, this.task.deviceType).subscribe(
        serial => {
          this.serial = serial;
          if (this.isrepair || this.task.type === "deinstallation") {
            if (this.task.install && this.serial === this.task.install.serial) {
              flag = true;
            } else {
              flag = false;
              let message = 'Device serial does not match. Make sure this is the correct device.';
              let alert = this.alertCtrl.create({
                title: 'Error!',
                message: message,
                buttons: ['OK']
              });
              alert.present();
            }
          } else {
            flag = true;
          }
          observer.next(flag);
        },
        e => {
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: e,
            buttons: ['OK']
          });
          alert.present();
          //observer.error(e);
        }
      );
    });
  }

  readyCheck() {
    let flag = this.code.length > 0;
    this.ready = flag;
  }

  isFirstTime() {
    return this.isreplace || (this.code && this.code.length > 0) ? false : true;
  }

  validateCode(serial) {
    return Observable.create(observer => {
      let flag = false;
      if (
        this.task.deviceType === Task.DeviceTypeEnum.FireAlarm &&
        serial.toLowerCase().indexOf('fireal') > 0
      ) {
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Security &&
        serial.toLowerCase().indexOf('secdev') > 0
      ) {
        // check serial
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Geyser &&
        serial.toLowerCase().indexOf('geyser') > 0
      ) {
        // check serial
        flag = true;
      } else if (
        this.task.deviceType === Task.DeviceTypeEnum.Congey &&
        serial.toLowerCase().indexOf('congey') > 0
      ) {
        // check serial
        flag = true;
      }

      if (flag) {
        observer.next('success');
      } else {
        observer.error('error');
      }
    });
  }

  updateTask() {
    let type = !this.isrepair ? 'code' : 'verified';
    let data = ['data'];
    this.validateCode(this.serial).subscribe(
      () => {
        if (this.isreplace) {
          this.tasksProvider.updateTaskData(this.task, 'newSerial', this.serial).subscribe(data => {
            // check
          });
        }

        let partial;
        const serial = this.serial;
        if (this.isreplace) {
          partial = {
            status: 'inprogress',
            install: {
              newSerial: serial,
              activationPassword: this.devicePass
            }
          };
        } else {
          partial = {
            status: 'inprogress',
            install: {
              serial: serial,
              activationPassword: this.devicePass
            }
          };
        }
        this.tasksProvider.updateTaskPartial(this.task.id, partial).subscribe(
          updateResult => {
            this.tasksProvider.updateTaskData(this.task, type, this.serial).subscribe(data => {
              this.tasksProvider.updateTaskData(this.task, 'test', null).subscribe(data => {
                this.tasksProvider.setSelectedTask(updateResult);
                this.navCtrl.pop();
              });
            });
          },
          err => {
            let message =
              err.error && err.error.message
                ? err.error.message
                : 'Failed to update task, please check your internet connection and try again.';
            let alert = this.alertCtrl.create({
              title: 'Error',
              message: message,
              buttons: ['OK']
            });
            alert.present();
          }
        );
      },
      error => {
        let message =
          'The serial does not match the device for this task. Please check if this is the correct serial of the device to be installed.';
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );
  }

  parseInputCode(code) {
    let input = code.replace('GEYSER', '').replace('SECDEV', '').replace('CONGEY', '');
    input = input.replace("snsecdev:", '').replace("sngeyser:", '').replace('sncongey:', '')
    input = input.trim()

    if (input.length === 8 && !this.task.deviceType.includes('fire')) {
      if (this.task.deviceType.includes('geyser')) {
        input = 'sngeyser:' + input + 'GEYSER'
      } else if (this.task.deviceType.includes('secdev')) {
        input = 'snsecdev:' + input + 'SECDEV'
      } else if (this.task.deviceType.includes('congey')) {
        input = 'sncongey:' + input + 'CONGEY'
      }
    }
    return input;
  }

  confirmCode(evt) {
    this.enableFlaslight = false;
    this.showBrowserScanner = false;
    this.torch = false;
    let value = this.parseInputCode(evt);
    this.scanCodeVerified = false;
    this.code = value;
    if (this.code.includes("=")) {
      this.devicePass = value.substring(value.indexOf("=") + 1);
      localStorage.setItem("lastPass", this.devicePass);
    }
    this.checkAndVerifyCode().subscribe(result => {
      if (result) {
        this.showBrowserScanner = false;
        this.scanCodeVerified = true;
      }
    });
  }

  onHasPermission(evt) {
    // alert("Perm: "+JSON.stringify(evt))
  }
  onCamerasFound(evt) {
    this.enableFlaslight = true;
    // alert("CAM: "+JSON.stringify(evt))

    this.cameras = evt.filter(cam => {
      return !cam.label.includes("IR");
    });

    if (this.cameras.length > 0) {
      this.selectedCamera = this.cameras[0];
    }
  }

  onTorchCompatible(evt) {
    // alert("TOurch: "+JSON.stringify(evt))
  }
  camerasNotFoundHandler(evt) {
    // alert("NOCAM: "+JSON.stringify(evt))
  }
  showQrTypeBox() {
    this.enableFlaslight = false;
    this.showBrowserScanner = false;
    this.scanCodeVerified = false;
    this.torch = false;
    this.showTypeBox = true;
  }
  browserScanner() {
    this.showBrowserScanner = true;
  }

  getCamera(evt) {
    return this.selectedCamera;
  }

  isSelected(itm) {
    return itm
  }

  selectAnswer($event) {
    this.formCange($event);
  }

  presentLoading(content: string = '') {
    this.loader = this.loadingCtrl.create({
      content
    });
    this.loader.present();
  }

  selectCheckAnswer(evt) {
    this.formCange(evt);
  }

  dateChange($event){
    this.resetInstallerAvalibility();
    this.formCange($event);
  }

  formCange(evt) {
    this.checkCanSchedule();

    if(this.canCheckAvalibleInstallers() && !this.selectedInstaller) this.getAvalibleInstallers();
  }
  canCheckAvalibleInstallers(){
    return this.selectedDate && this.selectedTime && this.checkDate();
  }

  getAvalibleInstallers(){
    let installers = [...this.installers];
    // todo: filter out pc installers somehow
    installers.map((installer, i) => {
      installers[i].available = true;
    })
  }


  checkCanSchedule() {
    if (this.selectedInstaller && this.selectedDate && this.selectedTime && !this.installerBusy) {
      this.installerBusy = false;
      this.canSchedule = true;
    }
  }

  checkDate() {
    const dateString = this.selectedDate + " " + this.selectedTime;
    const assignedDate = new Date(dateString.replace(/-/g, "/")).getTime();
    if (assignedDate < new Date().getTime()) {
      const message = 'The scheduled date is earlier than the current date.'
      let alert = this.alertCtrl.create({
        title: 'Warning',
        message: message,
        buttons: [
          {
            text: 'Ok',
            role: 'continue',
            handler: data => {
              this.selectedDate = null;
              this.selectedTime = null;
              this.canSchedule = false;
            }
          }
        ]
      });
      alert.present();
      return false;
    } else {
      return true;
    }
  }

  confirmScheduleTask() {
    const selectedInstallerData = this.installers.find(installer => installer.uid === this.selectedInstaller);
    const message = `Scheduling task for: <br />Name: <strong>${selectedInstallerData.firstName} ${selectedInstallerData.lastName}</strong> <br /> Date: <strong>${this.selectedDate}</strong> <br />Time: <strong>${this.selectedTime}</strong>`
    let alert = this.alertCtrl.create({
      title: 'Please Confirm',
      message: message,
      buttons: [
        {
          text: 'No',
          role: 'continue',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          role: 'ok',
          handler: data => {
            this.completeScheduleTask();
          }
        }
      ]
    });
    alert.present();
  }

  checkInstallerAvailability() {

    if (this.selectedInstaller && this.avalibilityCheckInProgress === false) {
      const dateString = this.selectedDate + " " + this.selectedTime;
      const assignedDate = new Date(dateString.replace(/-/g, "/"));

      this.presentLoading();
      this.avalibilityCheckInProgress = true;
      this.tasksProvider.checkInstallerAvailability(
        {
          snn: this.selectedInstaller,
          date: assignedDate.getTime()
        }
      ).subscribe(available => {
        this.loader.dismiss();
        this.avalibilityCheckInProgress = false;
        if (available) {
          this.installerBusy = false;
          this.canSchedule = true;
        } else {
          this.installerBusy = true;
          const msg = 'The chosen installer is not available at the selected time/date.<br /> Please select another time/date.';

          let alert = this.alertCtrl.create({
            title: 'Warning',
            message: msg,
            buttons: [
              {
                text: 'OK',
                role: 'continue',
                handler: data => {
                  console.log('Cancel clicked');
                }
              }
            ]
          });
          alert.present();
        }
      }, err => {
        this.avalibilityCheckInProgress = false;
        this.loader.dismiss();
      });
    }
  }

  completeScheduleTask() {
    this.presentLoading('Scheduling Task');
    this.tasksProvider.getTask(this.task.id).subscribe((taskResult: Task) => {

      const newCompany = taskResult.companyId.includes('snn:group:company:plumber-connect-')? this.authProvider.getScheduleCompany(): taskResult.companyId;
      if(taskResult.companyId !== newCompany){
        // Update installer company
        taskResult.companyId = newCompany;
        this.tasksProvider.updateTask(taskResult).subscribe(
          updateResult => {
            this.scheduleTask(updateResult);
          },
          error => {
            console.log('>>>>>>>>>>>>>>>>> error',error);
            this.loader.dismiss();
          }
        );
      } else {
        // Dont Update installer company
        this.scheduleTask(taskResult);
      }
    })
  }

  scheduleTask(taskResult: Task) {
    const dateString = this.selectedDate + " " + this.selectedTime;
    const assignedDate = new Date(dateString.replace(/-/g, "/"));
    taskResult.status = Task.StatusEnum.Scheduled;
    taskResult.userId = this.selectedInstaller;
    taskResult.assignedDate = assignedDate.getTime();
    taskResult.notify = true;

    this.tasksProvider.updateTask(taskResult, this.loader).subscribe(
      updateResult => {
        this.addNewNote();
      },
      error => {
        console.log('>> error',error);
      }
    );
  }

  afterSchedule(){
    this.loader.dismiss();
    const toast = this.toastController.create({
      message: 'Task Scheduled',
      showCloseButton: true,
      duration: 10000,
      position: 'bottom'
    });
    toast.present();
    this.navCtrl.popToRoot();
  }

  addNewNote(){
    if(this.newNote.trim() !== '' && this.newNote !== undefined) {
      this.tasksProvider.addNote(this.task, this.newNote.trim()).subscribe(response => {
        if(response.notes.length > 0){
          this.newNote = "";
        }
        this.afterSchedule();
      })
    } else {
      this.afterSchedule();
    }
  }

  showInstallerPage(){
    let commentModal = this.modalCtrl.create(SchedulerModalPage, {
      installers: this.installers,
    });

    commentModal.onDidDismiss(selectedInstaller => {
      if (selectedInstaller) {
        this.selectedInstaller = selectedInstaller.uid
        this.selectedInstallerName = selectedInstaller.firstName + " " + selectedInstaller.lastName;
        this.checkCanSchedule();
      }
    });

    commentModal.present();
  }

  setInitialDateVal(){
    const now = new Date();
    now.setDate(now.getDate() + 1);
    this.initialDate = now.toISOString();
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-schedule/task-schedule.ts